<template>
    <div class="dark login-dark container responsive" :style="{backgroundImage: backgroundImage}">
        <div class="box">
            <div class="card card-w-title">
                <div style="text-align: center">
                    <img style="max-width: 275px; max-height: 150px;" :src="logo" alt="">
                </div>
                <h2 style="text-align: center; margin-top: 30px">{{ $t('auth.error500') }}</h2>
                <div style="text-align: center; margin-top: 30px">
                    <a class="cursor-pointer" :href="`#/login`">
                        <Button :label="$t('auth.reload')" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Error",

        computed:{

            server(){
              return process.env.VUE_APP_SERVER;
            },

            backgroundImage(){
                return 'url(assets/layout/images/default-allpaper.jpeg)';
            },

            logo(){
                return 'assets/layout/images/logo-ancestryline-original-branco.jpeg';
            }

        },
    }
</script>

<style scoped>
    body {
        margin: 0px;
    }
    .container {
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .box {
        width: 300px;
        height: 450px;
        background-color: #1d1e23de;
        border-radius: 5px;
    }

    .dark .card {
        background: transparent;
    }

    .responsive {
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }

</style>
